import React from 'react';

import {ReactComponent as Arraycon} from '../../../../../../../assets/main/groups/main-table/array-right.svg';
import {payments} from "./index";
import {useAppSelector} from "../../../../../../../common/hook";
import {getCabinetData} from "../../../../../../../entities/Cabiner/model/selectors/getCabinetData/getCabinetData";
import {ALL_TRANSFERS_PAYMENTS, BANK_TRANSFERS_TITLE} from "../../../../../../../entities/constants/constants";
import {NothingYetMessage} from "../../../../nothing-yet-message/NothingYetMessage";
import {Link} from "react-router-dom";

export const PaymentsCart = () => {
    const cabinetData = useAppSelector(getCabinetData);


    return (
        <div className="info-card">
            <div className="info-card-hdr">
                <div className="title-box">
                    <p className="info-card-title h4">{BANK_TRANSFERS_TITLE}</p>
                </div>
                {cabinetData?.bankTransfers?.count && (
                    <span className="sub-data">{cabinetData?.bankTransfers?.count}</span>
                )}
            </div>
            <div className="info-card-content">
            {cabinetData?.bankTransfers?.items && cabinetData?.bankTransfers?.items.length > 0 ? (
                <>
                    {cabinetData?.bankTransfers?.items.map((item, index) => (
                        <div className="row" key={index}>
                            <div className="data-payment-grid">
                                <div className="col">
                                    <p>{item.title}</p>
                                    <div className="group-item-data">
                                        <span className={`complited-count ${item.status === 'successful' ? 'completed' : 'pending'}`}>
                                            {item.statusTitle}
                                        </span>
                                        <p>{item.courseTitle}</p>
                                    </div>
                                </div>
                                <div className="col price-col">
                                    <span className="price">{item.amount}</span>
                                    <time className="time small-text">
                                        {item.date}, {item.time}
                                    </time>
                                </div>
                            </div>
                        </div>
                    ))}
                    <div className="block-arrow-link">
                        <Link to="/payment-history" className="arrow-link">
                                {ALL_TRANSFERS_PAYMENTS}
                                <Arraycon />
                        </Link>
                    </div>
                </>
            ) : (
                <NothingYetMessage />
            )}
            </div>
        </div>
    );
};


